export default __webpack_public_path__ + "static/media/copy.6d9ba36d.svg";